export { default } from "./CarverticalWidget";
export {
  default as CarverticalWidget,
  VIN_DETAIL_TITLE,
  buildCarverticalUrl,
  findVinInDetails,
  trackCarverticalVinLinkShown,
  trackCarverticalVinLinkClick
} from "./CarverticalWidget";
export { default as CarverticalVinLink } from "./CarverticalVinLink";



// WEBPACK FOOTER //
// ./src/components/CarverticalWidget/index.ts